import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import ForcePasswordChange from "./ForcePasswordChange";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="protected-loading">
        <div className="w-12 h-12 border-2 border-electric border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user || user === false) {
    return <Navigate to="/admin/login" replace />;
  }

  // Allow both 'admin' and 'church_admin' into the admin area
  if (!["admin", "church_admin"].includes(user.role)) {
    return <Navigate to="/admin/login" replace />;
  }

  // Force password change on first login before granting access
  if (user.must_change_password) {
    return <ForcePasswordChange />;
  }

  return children;
}
